import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const ValuationSummaryCard = ({ token }) => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/pas-ledger/valuation-summary`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setD(r.data)).catch(() => {}); }, [token]);
  if (!d) return null;
  const ratio = d.coverage_ratio == null ? 'n/a' : `${(d.coverage_ratio * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6" data-testid="valuation-summary-card">
      <h3 className="text-white font-semibold flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-emerald-400" /> How BETH is valued</h3>
      <p className="text-sm text-slate-400 mt-2" data-testid="valuation-summary-text">{d.summary}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 text-sm">
        {[['Your rate', d.your_rate, 'valuation-your-rate'], ['Documented notes', d.notes_counted, 'valuation-notes'],
          ['Documented receivables', usd(d.receivables_usd), 'valuation-receivables'], ['Coverage of subscriber BETH', ratio, 'valuation-coverage']].map(([k, v, id]) => (
          <div key={k} className="bg-slate-900 rounded-lg p-3"><p className="text-xs text-slate-500">{k}</p><p className="text-white font-semibold" data-testid={id}>{v}</p></div>
        ))}
      </div>
      {d.your_note && <p className="text-xs text-slate-500 mt-3" data-testid="valuation-your-note">Your note {d.your_note.note_no} ({d.your_note.agreement_no}) · {d.your_note.status.replace('_', ' ')} · outstanding {usd(d.your_note.outstanding_usd)} · {d.your_note.secured ? 'secured' : 'unsecured'}</p>}
      <p className="text-[11px] text-slate-600 mt-2">Policy {d.policy_version} · read-only summary</p>
    </div>
  );
};
